// src/contexts/SelectedLocationContext.tsx

import React, { createContext, useState, ReactNode } from "react";

interface SelectedLocationContextType {
  domain: string | null;
  setDomain: React.Dispatch<React.SetStateAction<string | null>>;
  category: string | null;
  setCategory: React.Dispatch<React.SetStateAction<string | null>>;
  product: string | null;
  setProduct: React.Dispatch<React.SetStateAction<string | null>>;
}

const SelectedLocationContext = createContext<
  SelectedLocationContextType | undefined
>(undefined);

export const SelectedLocationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [domain, setDomain] = useState<string | null>(null);
  const [category, setCategory] = useState<string | null>(null);
  const [product, setProduct] = useState<string | null>(null);

  return (
    <SelectedLocationContext.Provider
      value={{
        domain,
        setDomain,
        category,
        setCategory,
        product,
        setProduct,
      }}
    >
      {children}
    </SelectedLocationContext.Provider>
  );
};

export const useSelectedLocation = () => {
  const context = React.useContext(SelectedLocationContext);
  if (context === undefined) {
    throw new Error(
      "useSelectedLocation must be used within a SelectedLocationProvider",
    );
  }
  return context;
};
